import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { OptionTagContentProps as Props } from './types';
import { Avatar, Divider, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';

export const OptionTagContent = memo(({ className, logoSrc, title }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('OptionTagContent', className)}
      sx={SX.root}
    >
      <Avatar src={logoSrc} variant="circular" size={24}>
        <Icon name="business" size={16} color="grey.100" />
      </Avatar>
      <Divider orientation="vertical" flexItem color="primary" />
      <Typography variant="body2" color="grey.700" fontWeight={400}>
        {title}
      </Typography>
    </Styled.Wrapper>
  );
});

OptionTagContent.displayName = 'OptionTagContent';
